import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { Offer, Job, OfferAllocation, DocumentSegment, ProductLineItem, Product, Media, Decoration, PublicOfferAsset, User, PublicOfferExtraInfos } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class OfferService implements RequestService {

  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'offer';  // URL to web api

  constructor(
    private http: HttpClient,
    ) { }


  /** GET product by id. Will 404 if id not found */
  /** GET product by id. Will 404 if id not found */
  getOffers(val:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${val}?&include=publicOfferAssets.product&include=publicOfferAssets&include=publicOfferExtraInfos&include={"path":"disclaimers","sort":"id"}&include=offerType&include=publicOfferAssets.media&include=publicOfferAssets.decoration`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Offer[]>(encodeURI(url),{
       headers: headers
    })
  }


  getOffer(offer:Offer,includeAssets:boolean=true): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let url = `${environment.baseURL}${this.serviceUrl}/uuid/${offer.uuid}?include=offerViews.viewTemplate&include=offerType&include={"path":"disclaimers","sort":"id"}&include=allocation.viewTemplate`;

    if(includeAssets)
      url += `&include=publicOfferAssets.product&include=publicOfferAssets&include=publicOfferExtraInfos&include=disclaimers&include=publicOfferAssets.decoration&include=publicOfferAssets.media&include=publicOfferAssets.product.productassets.media`;

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Offer>(url,{
       headers: headers
    })

  }

  getOfferTypes(): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}offertype/all`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Offer>(url,{
       headers: headers
    })

  }

  getInactiveOfferType(offer:Offer): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}offertype/all?offeruuid=${offer.uuid}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Offer>(url,{
       headers: headers
    })

  }

  getAltFields(): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}themes/all`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    return this.http.get<any>(url,{
       headers: headers
    })
  }

  getFields(): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}mandatoryfields/publicoffer`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    return this.http.get<any>(url,{
       headers: headers
    })
  }

  getCompany(company:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}disclaimer/company/${company}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<any>(encodeURI(url),{
       headers: headers
    })
  }

  hasJsonStructure(str:string):boolean {

    if (typeof str !== 'string') return false;
        try {
            const result = JSON.parse(str);
            const type = Object.prototype.toString.call(result);
            return type === '[object Object]'
                || type === '[object Array]';
        } catch (err) {
            return false;
        }
  }



      updateOffer(offer:Offer,job:Job,allocation:OfferAllocation,documentSegment:DocumentSegment): Observable<any> {
        //const body = {e: 'username', p: 'password', rt:'json'};
        let action= offer.uuid?'save':'save'
        const url = `${environment.baseURL}${this.serviceUrl}/${action}`;
        const ignoreKeys = ['publicOfferAssets','publicDecorationAssets','publicOfferExtraInfos'];
        const ignoreAssetKeys = ['product','media'];
        const decorationIgnoreKeys = ['name','type','isHero','originOwner'];

        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

        let urlSearchParams = new URLSearchParams();

        // Object.keys(offer).forEach(function (key) {
        //   urlSearchParams.append(key, offer[key]);
        // });
        // let regions = offer.campaignRegions.map(function(region) {
        //           return region['name'];
        //         });
        // let startDate = this.datePipe.transform(offer.startDate);
        // let endDate = this.datePipe.transform(offer.endDate);
        // let data = JSON.stringify(offer);
        //
        // urlSearchParams.append('data',data);
        //
        // let bodyParams = urlSearchParams.toString();

    console.log("offer: ");
    console.log(offer['disclaimers']);

        let data = new Offer();

        if(offer.uuid)
          data.uuid = offer.uuid;

        if(documentSegment)
            data.pageUUID = documentSegment.uuid;


          Object.keys(offer).forEach(function (key) {

            if(ignoreKeys.indexOf(key) === -1 && offer[key]){
              console.log("pre data URI " + key + ": ", offer[key]);


              if (offer[key] != null && offer[key] != ""){
                var isJsonString = this.hasJsonStructure(JSON.stringify(offer[key]));

                console.log("isJsonString: " + isJsonString);

                if (isJsonString){
                  Object.keys(offer[key]).forEach(function (jsonKey) {

                    console.log("pre offer[key][jsonKey] " + jsonKey + ": ", offer[key][jsonKey]);

                    if (typeof offer[key][jsonKey] === 'object'){
                      Object.keys(offer[key][jsonKey]).forEach(function (jsonKey2) {
                      console.log("jsonKey2: " ,  jsonKey2);
                      console.log("jsonKey2 value pre offer[key][jsonKey][jsonKey2]: " ,  offer[key][jsonKey][jsonKey2]);

                        offer[key][jsonKey][jsonKey2] = encodeURIComponent(offer[key][jsonKey][jsonKey2]);
                        //console.log("jsonKey value post: " ,  offer[key][jsonKey][jsonKey2]);
                        //console.log("offer[key] post: " ,  offer[key]);

                      },offer[key])

                    }
                    else{

                      offer[key][jsonKey] = encodeURIComponent(offer[key][jsonKey]);
                    }

                  },offer[key])
                  data[key] =  offer[key];
                  console.log("data[key]: " ,  data[key]);

                }
                else{
                  data[key] =  encodeURIComponent(offer[key]);
                }
              }
              else{
                data[key] =  offer[key];
              }
              //console.log("post data URI " + key + ": ", data[key]);
            }
          }, this);

          var poa = [];
          // build the public offer assets
          if(offer.publicOfferAssets){

            offer.publicOfferAssets.map(asset =>{

              let tmpAsset = new ProductLineItem();


              Object.keys(asset).forEach(function (key) {
                if(ignoreAssetKeys.indexOf(key) === -1 && asset[key]){

                  if (asset[key] != null && asset[key] != ""){
                     tmpAsset[key] =  encodeURIComponent(asset[key]);
                  }
                  else{
                     tmpAsset[key] =  asset[key];
                  }
                 }
              });

              if(asset.product){

                if ( asset.liner === true ) {
                  asset.liner = 'Y';
                } else if ( asset.liner === false )  {
                  asset.liner = 'N';
                } else if ( asset.liner === null )  {
                  asset.liner = null;
                }

                tmpAsset.product = new Product();
                tmpAsset.liner = asset.liner;
                tmpAsset.product.uuid = asset.product.uuid;
                tmpAsset.product.hero = asset.isHero?'Yes':'';
              }else{
                tmpAsset.media = new Media();
                tmpAsset.media.uuid = asset.media.uuid;
                //tmpAsset.media.hero = asset.isHero?'Yes':'';
              }

              if(tmpAsset){
                poa.push(tmpAsset);
              }

            })

            data.publicOfferAssets = poa;
            //urlSearchParams.append('publicOfferAssets',publicOfferAssets);
          }

          var assets = [];
          if(offer.publicDecorationAssets){

            offer.publicDecorationAssets.map(asset =>{
              if(asset.decoration){
                let tmpAsset = {decoration:null};
                Object.keys(asset).forEach(function (key) {
                   if(decorationIgnoreKeys.indexOf(key) === -1 && asset[key]){
                     if (asset[key] != null && asset[key] != ""){
                         tmpAsset[key] =  encodeURIComponent(asset[key]);
                     }
                     else{
                         tmpAsset[key] =  asset[key];
                     }
                    }
                });
                if (asset.decoration.name != null){
                  tmpAsset.decoration = {uuid:asset.decoration.uuid,name:encodeURIComponent(asset.decoration.name)};
                }
                else{
                  tmpAsset.decoration = {uuid:asset.decoration.uuid,name:asset.decoration.name};
                }
            assets.push(tmpAsset);
          }else if(asset.media){
            let tmpAsset = {media:null};

            Object.keys(asset).forEach(function (key) {
               if(decorationIgnoreKeys.indexOf(key) === -1 && asset[key]){
                   if (asset[key] != null && asset[key] != ""){
                      tmpAsset[key] =  encodeURIComponent(asset[key]);
                   }
                   else{
                      tmpAsset[key] =  asset[key];
                   }
                   }
                });
                let owner = '';

                tmpAsset.media = {uuid:asset.media.uuid,hero:asset.media.isHero?'Yes':'No',originOwner:asset.originOwner, selectedMedia:asset.media.selected?'true':'false'};
                assets.push(tmpAsset);
              }

            })

            if(data.publicOfferAssets)
              data.publicOfferAssets = data.publicOfferAssets.concat(assets);
            else
              data.publicOfferAssets = assets;

          }

          var poei = [];
          if(offer.publicOfferExtraInfos){

            offer.publicOfferExtraInfos.map(asset =>{

              let tmpAsset = new PublicOfferExtraInfos();

              Object.keys(asset).forEach(function (key) {
                if(ignoreAssetKeys.indexOf(key) === -1 && asset[key]){

                  if (asset[key] != null && asset[key] != ""){
                     tmpAsset[key] =  encodeURIComponent(asset[key]);
                  }
                  else{
                     tmpAsset[key] =  asset[key];
                  }
                 }
              });

              if(tmpAsset){
                poei.push(tmpAsset);
              }

            })

            data.publicOfferExtraInfos = poei;
          }


          data.callout = offer.callout?encodeURIComponent(offer.callout):null;

          urlSearchParams.append('data',JSON.stringify(data));
          let bodyParams = urlSearchParams.toString();

        /*if(offer.uuid)
          urlSearchParams.append('uuid',offer.uuid);

          Object.keys(offer).forEach(function (key) {

            if(ignoreKeys.indexOf(key) === -1)
              urlSearchParams.append(key, offer[key]);
          });

          var poa = [];
          // build the public offer assets
          if(offer.publicOfferAssets){

            offer.publicOfferAssets.map(product =>{
              var prodAsset = {code:'',product:{uuid:product.uuid}};

              // for each product asset
              product.productassets.map(asset =>{
                let tmpAsset = {code:'',media:{uuid:asset.uuid}};
                poa.push(tmpAsset);
              })

              poa.push(prodAsset);
            })

            let publicOfferAssets = JSON.stringify(poa);
            urlSearchParams.append('publicOfferAssets',publicOfferAssets);
          }*/


        // urlSearchParams.append('code',offer.code);
        // urlSearchParams.append('name',offer.name);
        // urlSearchParams.append('startDate',startDate);
        // urlSearchParams.append('endDate',endDate);
        // urlSearchParams.append('pages',offer.pages.toString());
        // urlSearchParams.append('regions',regions.toString());
        // urlSearchParams.append('height',offer.height.toString());
        // urlSearchParams.append('width',offer.width.toString());
        // urlSearchParams.append('outputSize',offer.outputSize.toString());
        // urlSearchParams.append('authoriserId',offer.authoriserId.toString());
        // urlSearchParams.append('offermanagerId',offer.offermanagerId.toString());
        // urlSearchParams.append('accountManagerId',offer.accountManagerId.toString());


        //let bodyParams = urlSearchParams.toString();

        return this.http.post<Offer>(url,bodyParams,{
           headers: headers
        })

      }

  batchUpdateOffer(offers:Offer[]): Observable<any> {
    const url = `${environment.baseURL}${this.serviceUrl}/batchedit`;
    const ignoreKeys = ['publicOfferAssets','region','page'];
const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    let offerArray:any = [];
    let data = {data:null};

    for(let offer of offers){
      let tmpOffer = new Offer();
      tmpOffer.uuid = offer.uuid;

      Object.keys(offer).forEach(function (key) {
        if(ignoreKeys.indexOf(key) === -1 && offer[key])
          tmpOffer[key] =  offer[key];

          if (offer[key] != null && offer[key] != ""){
            // tmpOffer[key] =  encodeURIComponent(offer[key]);
            tmpOffer[key] =  offer[key];
          }
          else{
            tmpOffer[key] =  offer[key];
          }
      });

      var poa = [];
      // build the public offer assets
      if(offer.publicOfferAssets){

        offer.publicOfferAssets.map(asset =>{
          let tmpAsset;
          if(asset.product){
            tmpAsset = {id:asset.id,code:asset.code,product:{uuid:asset.product.uuid}};

          }else{
            tmpAsset = {id:asset.id,assetDescr:asset.assetDescr,code:asset.code,media:{uuid:asset.uuid}};
          }
          if(tmpAsset)
            poa.push(tmpAsset);
        })

        // set the asset description of the first asset

        tmpOffer.publicOfferAssets = poa;

      }
      offerArray.push(tmpOffer);
    }
    data.data = offerArray;
    urlSearchParams.append('data',JSON.stringify(data));

    let bodyParams = urlSearchParams.toString();
    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  getFaveOffers(): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}person?include=favouriteoffers&include=favouriteoffers.offerType&include=favouriteoffers.publicOfferAssets.product&include=favouriteoffers.publicOfferAssets.decoration&include=favouriteoffers.publicOfferAssets.media&include=favouriteoffers.publicOfferAssets&include=favouriteoffers.disclaimers&include=favouriteoffers.offerType`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Offer[]>(encodeURI(url),{
       headers: headers
    })
  }

  updateFaveOffers(code:string,action:string): Observable<any> {

    const url = `${environment.baseURL}person/${action}/favoffer`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('offerUUID',code);
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })
  }

  setOfferLock(code:string,lockStatus:string): Observable<any> {

    const url = `${environment.baseURL}offer/lock`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('offerUUID',code);
    urlSearchParams.append('lockStatus',lockStatus);
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })
  }

  copyOffer(code:string,jobs:Job[]): Observable<any> {

    // const requests = jobs.map(job => {
    //   const url = `${environment.baseURL}${this.serviceUrl}/copy`;

    //
    //   const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    //   let urlSearchParams = new URLSearchParams();
    //   urlSearchParams.append('offerUUID',code);
    //   urlSearchParams.append('jobUUID',job.uuid);

    //   let bodyParams = urlSearchParams.toString();

    //   return this.http.post<Offer>(url,bodyParams,{
    //      //params : httpParams
    //      headers: headers
    //   })
    // });

    // BW-299 Make sure calls are sync.
    return Observable.defer(async () => {
      const url = `${environment.baseURL}${this.serviceUrl}/copy`;
      let req:any;

      const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

      for(var i = 0; i< jobs.length; i++){
        const job = jobs[i];
        let urlSearchParams = new URLSearchParams();
        urlSearchParams.append('offerUUID',code);
        urlSearchParams.append('jobUUID',job.uuid);

        const bodyParams = urlSearchParams.toString();
        // if(!req){
          req = await this.http.post<Offer>(url,bodyParams,{
            headers: headers
         }).toPromise();
        // }
        // else{
        //   req = req + await this.http.post<Offer>(url,bodyParams,{
        //     headers: headers
        //  }).toPromise();
        // }

      }
      return req;

    });
  }

  moveOffer(code:string,pageUUID:string,position?:string): Observable<any> {

    const url = `${environment.baseURL}${this.serviceUrl}/move`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('offerUUID',code);
    urlSearchParams.append('pageUUID',pageUUID);
    if(position)
      urlSearchParams.append('position',position);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  assignOffer(code:string,pageUUID:string): Observable<any> {

    const url = `${environment.baseURL}${this.serviceUrl}/assign`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('offerUUID',code);
    urlSearchParams.append('pageUUID',pageUUID);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  allocateOffer(code:string,offerAllocId:string): Observable<any> {
    const url = `${environment.baseURL}${this.serviceUrl}/assign/allocation`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('offerUUID',code);
    urlSearchParams.append('offerAllocId',offerAllocId);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  allocateFaveOffer(code:string,offerAllocId:string): Observable<any> {

    const url = `${environment.baseURL}${this.serviceUrl}/assignfav`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('offerUUID',code);
    urlSearchParams.append('offerAllocId',offerAllocId);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  unallocateOffer(code:string): Observable<any> {
    const url = `${environment.baseURL}${this.serviceUrl}/unallocate`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('offerUUID',code);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  swapOffers(code1:string,code2:string): Observable<any> {

    const url = `${environment.baseURL}${this.serviceUrl}/swap`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('aUUID',code1);
    urlSearchParams.append('bUUID',code2);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  moveAllocation(id:string,position:string): Observable<any> {

    const url = `${environment.baseURL}offerallocation/move`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('allocationId',id);
    if(position)
      urlSearchParams.append('pos',position);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  removeAllocation(id:string): Observable<any> {

    const url = `${environment.baseURL}offerallocation/remove`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('allocationId',id);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  addMedia(filename:string, uuid:string, token:string): Observable<any> {

    const url = `${environment.baseURL}offer/addmedia`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('filename',filename);
    urlSearchParams.append('offerUUID',uuid);
    urlSearchParams.append('token',token);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Offer>(url,bodyParams,{
       headers: headers
    })

  }

  getOfferHistory(uuid:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let url = `${environment.baseURL}${this.serviceUrl}/history/${uuid}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Offer>(url,{
       headers: headers
    })

  }

  getOfferHSSCodes(): Observable<any> {

    let url = `${environment.baseURL}${this.serviceUrl}/hsscodes`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<any>(url,{
       headers: headers
    })

  }

  getPreferences(): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}company/preferences`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    return this.http.get<any>(url,{
       headers: headers
    })
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better offer of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/offer.service.ts